

function claMonths(salPolicy) {
    let startDate = salPolicy.effectiveDate;
    let endDate = salPolicy.expireDate;
    if (startDate == "" || endDate == "") {
        return -1;
    }
    return getIntervalMonth(startDate, endDate);
}
/**获取日期之间的月数余数*/
function getIntervalMonth(startDate, endDate) {
    startDate = startDate.split("-");
    endDate = endDate.split("-");
    let months = (parseInt(endDate[0]) - parseInt(startDate[0])) * 12 + (parseInt(endDate[1]) - parseInt(startDate[1]));
    // 超过5年按5年算
    if(months >= 60) {
        return 12
    }
    if ((endDate[2] - startDate[2]) <= 0) {
        return (months - 1) % 12+1;
    }
    return months % 12+1;
}

/**
 * 根据月数差值获取费率
 * @param months
 */
function getFeilv(months) {
    var feilv={'0':'0.1','1':'0.2','2':'0.3','3':'0.4','4':'0.5','5':'0.6','6':'0.7','7':'0.8','8':'0.85','9':'0.9','10':'0.95','11':'1'};
    return feilv[months];
}

/**获取两个日期中的年份*/
function claDate(dateStr1, dateStr2,obj) {
    let strs1 = dateStr1.split('-');
    let strs2 = dateStr2.split('-');
    if (strs1.length < 3 || strs2.length < 3) return 0;
    let months=(parseInt(strs2[0])-parseInt(strs1[0]))*12 + (parseInt(strs2[1])-parseInt(strs1[1]));
    if(strs2[2] <= strs1[2]){
        months=months-1;
    }
    let years=parseInt(months/12)+1;
    setRentAndConverage(years,obj);
    return years;
}

/**
 * 根据保险期间设置租金和保额(保险期间小于一年时，第二年和第三年的保额和租金设置为0)
 * @param years
 */
function setRentAndConverage(years,obj){
    if(!years) return;
    if(years=='1'){
        obj.salPolicy.destination2 = '';
        obj.salPolicy.destination3= '';
        obj.salPolicy.destination4='';
        obj.salPolicy.destination5='';
        for(let item of obj.tableData){
            item.bdieCoverage2='';
            item.bdieCoverage3='';
            item.bdieCoverage4='';
            item.bdieCoverage5='';
        }
    }else if(years=='2'){
        obj.salPolicy.destination3='';
        obj.salPolicy.destination4='';
        obj.salPolicy.destination5='';
        for(let item of obj.tableData){
            item.bdieCoverage3='';
            item.bdieCoverage4='';
            item.bdieCoverage5='';
        }
    }else if(years=='3'){
        obj.salPolicy.destination4='';
        obj.salPolicy.destination5='';
        for(let item of obj.tableData){
            item.bdieCoverage4='';
            item.bdieCoverage5='';
        }
    }else if(years=='4'){
        obj.salPolicy.destination5='';
        for(let item of obj.tableData){
            item.bdieCoverage5='';
        }
    }

}




export const calcTotalPricesA = function (obj) {//计算保费
    console.log(obj,"--->obj")
        let converage1=0,converage2=0 ,converage3=0,converage4=0 ,converage5=0;
        let totalAmount=0;
        for(let item of obj.tableData){
            let insured_converage1=0,insured_converage2=0 ,insured_converage3=0,insured_converage4=0 ,insured_converage5=0;
            let insured_totalAmount=0;
            if(item.bdieCoverage1 != "" && !isNaN(item.bdieCoverage1)){
                converage1+=parseInt(item.bdieCoverage1)||0;
                insured_converage1+=parseInt(item.bdieCoverage1)||0;
            }
            if(item.bdieCoverage2 != "" && !isNaN(item.bdieCoverage2)){
                converage2+=parseInt(item.bdieCoverage2)||0;
                insured_converage2+=parseInt(item.bdieCoverage2)||0;
            }
            if(item.bdieCoverage3 != "" && !isNaN(item.bdieCoverage3)){
                converage3+=parseInt(item.bdieCoverage3)||0;
                insured_converage3+=parseInt(item.bdieCoverage3)||0;
            }
            if(item.bdieCoverage4 != "" && !isNaN(item.bdieCoverage4)){
                converage4+=parseInt(item.bdieCoverage4)||0;
                insured_converage4+=parseInt(item.bdieCoverage4)||0;
            }
            if(item.bdieCoverage5 != "" && !isNaN(item.bdieCoverage5)){
                converage5+=parseInt(item.bdieCoverage5)||0;
                insured_converage5+=parseInt(item.bdieCoverage5)||0;
            }
			console.log(converage1, insured_converage1)
			console.log(converage2, insured_converage2)
			console.log(converage3, insured_converage3)
			console.log(converage4, insured_converage4)
			console.log(converage5, insured_converage5)
            let salPolicy = obj.salPolicy //policy保单信息
            
            // 计算单人保费
            let months=claMonths(salPolicy);
            let years=claDate(salPolicy.effectiveDate,salPolicy.expireDate,obj);
            if(months != -1){
                if(years <= 1){
                    insured_totalAmount=insured_converage1*getFeilv(months-1);
                }else if(years<=2 && years > 1){
                    insured_totalAmount=insured_converage1+insured_converage2*getFeilv(months-1);
                }else if(years > 2){
                    insured_totalAmount=insured_converage1+insured_converage2+insured_converage3*getFeilv(months-1);
                    if(years > 3){
                        insured_totalAmount=insured_converage1+insured_converage2+insured_converage3+insured_converage4*getFeilv(months-1);
                    }
                    if(years > 4){
                        insured_totalAmount=insured_converage1+insured_converage2+insured_converage3+insured_converage4+insured_converage5*getFeilv(months-1);
                    }
                }
            }
            insured_totalAmount = Math.ceil(insured_totalAmount * 0.0012);
            item.premiumComputed = insured_totalAmount //个人保费
            totalAmount += insured_totalAmount;
        }
        return totalAmount
};
